import React from "react";
import {
  SectionTitle,
  StorySliderSection,
  StoryWrapper,
  TextArea,
} from "../../Home/styled";
import StorySlider from "../components/StorySlider";
import { VisionStoryStyle } from "../../Vision/styled";

const AssetSectionStory = () => {
  return (
    <VisionStoryStyle className="assets">
      <StoryWrapper type="1" full="1">
        <StorySliderSection type="1">
          <TextArea>
            <SectionTitle>
              <small>스토리</small>
              서비스 / 솔루션
            </SectionTitle>
          </TextArea>
          <StorySlider />
        </StorySliderSection>
      </StoryWrapper>
    </VisionStoryStyle>
  );
};

export default AssetSectionStory;
